import { render, staticRenderFns } from "./ResultPreview.vue?vue&type=template&id=483e4981&scoped=true&"
import script from "./ResultPreview.vue?vue&type=script&lang=js&"
export * from "./ResultPreview.vue?vue&type=script&lang=js&"
import style0 from "./ResultPreview.vue?vue&type=style&index=0&id=483e4981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483e4981",
  null
  
)

export default component.exports